import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/icon/Icon';

interface IBrandProps {
  asideStatus: boolean;
  setAsideStatus(...args: unknown[]): unknown;
}
const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
  return (
    <div className='brand'>
      <div className='brand-logo'>
        <h1 className='brand-title'>
          <Link to='/' aria-label='Logo' style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            {/* Logo Icon - 紫色主题 */}
            <span
              style={{
                width: '1.75rem',
                height: '1.75rem',
                background: 'linear-gradient(135deg, #7c5cfc, #9d85fc)',
                borderRadius: '0.375rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: '0.875rem',
              }}>
              🏷
            </span>
            {/* 标题文字 - 仅在展开时显示 */}
            {asideStatus && (
              <span style={{ fontSize: '1rem', fontWeight: 600, color: '#262626' }}>
                会员标签系统
              </span>
            )}
          </Link>
        </h1>
      </div>
      <button
        type='button'
        className='btn brand-aside-toggle'
        aria-label='Toggle Aside'
        onClick={() => setAsideStatus(!asideStatus)}>
        <Icon icon='FirstPage' className='brand-aside-toggle-close' />
        <Icon icon='LastPage' className='brand-aside-toggle-open' />
      </button>
    </div>
  );
};

export default Brand;
